<template>
	<div class="flex xl12 lg12 md12 mx-auto">
		<vue-pull-refresh :on-refresh="onRefresh" :config="pullConfig">
			<v-card style="width: 100%" color="transparent" elevation="0">
				<v-card-title class="px-1 pt-0">
					<h1 class="d-block text-xs-left">
						<span class="hidden-sm-and-down">Historie<br /></span>
						<small
							>Totaal openstaand: &euro; {{ totalOpen | toCurrency }}</small
						>
					</h1>

					<v-spacer></v-spacer>
					<div class="d-inline-flex">
						<v-text-field
							prepend-inner-icon="search"
							label="Zoeken"
							single-line
							hide-details
							v-model="search"
							style="min-width: 260px"
						></v-text-field>
						<history-filter @setFilter="setFilter"></history-filter>
					</div>
				</v-card-title>
				<v-data-table
					v-bind:headers="headers"
					v-bind:items="items"
					v-bind:pagination.sync="pagination"
					:rows-per-page-items="[25, 50]"
					no-data-text="..."
					item-key="name"
					:loading="loading"
				>
					<template slot="headers" slot-scope="props">
						<tr class="hidden-xs-only">
							<th
								v-for="header in props.headers"
								:key="header.text"
								:class="[
									'text-xs-left column sortable',
									pagination.descending ? 'desc' : 'asc',
									header.value === pagination.sortBy ? 'active' : ''
								]"
								@click="changeSort(header.value)"
							>
								{{ header.text }}
								<v-icon>arrow_upward</v-icon>
							</th>
						</tr>
					</template>
					<v-progress-linear
						slot="progress"
						color="blue"
						indeterminate
					></v-progress-linear>
					<template slot="items" slot-scope="props">
						<tr :active="props.selected">
							<td
								class="hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								{{ props.item.reservationNumber }}
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								{{ props.item.firstname }} {{ props.item.lastname }}
								<span v-if="props.item.companyname">
									- {{ props.item.companyname }}</span
								>
								{{ getTempCustomer(props.item) }}
								<br />
								<small>{{ props.item.phoneno }}</small>
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								{{ props.item.unitDescription }}
								<br />
								<small>{{ props.item.remark }}</small>
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								&euro; {{ props.item.totalCosts | toCurrency }}
								<br />
								<small v-if="props.item.paid === '0'"
									>&euro;
									{{
										(props.item.totalCosts - props.item.amountPaid) | toCurrency
									}}
									openstaand</small
								>
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								{{ utils.getFormattedDate(props.item.startDate, true) }}
							</td>
							<td
								class="text-xs-left hidden-xs-only"
								@click="showHistory(props.item, false)"
							>
								{{ utils.getFormattedDate(props.item.endDate, true) }}
							</td>
							<!-- Mobile -->
							<td
								class="text-xs-left hidden-sm-and-up itemRow"
								v-on:click.prevent.stop="showHistory(props.item, false)"
							>
								<h3>
									{{ props.item.firstname }} {{ props.item.lastname
									}}<span v-if="props.item.companyname">
										- {{ props.item.companyname }}</span
									>
								</h3>
								#{{ props.item.reservationNumber }} {{ props.item.car
								}}<br />Totaalbedrag: &euro;
								{{ utils.getFormattedAmount(props.item.totalCosts) }}
								<small v-if="props.item.paid === '0'"
									>&euro;
									{{
										utils.getFormattedAmount(
											props.item.totalCosts - props.item.amountPaid
										)
									}}
									openstaand</small
								>
								<br />{{
									utils.getFormattedDate(props.item.startDate, true)
								}}
								({{ utils.getDayDescription(props.item.startDate) }}) <br />{{
									utils.getFormattedDate(props.item.endDate, true)
								}}
								({{ utils.getDayDescription(props.item.endDate) }})
								<span
									class="other reservationStatus"
									v-if="props.item.amountPaid !== props.item.totalCosts || props.item.paid === '-1'"
									>DAGEN OPEN: {{ props.item.daysOpen }}</span
								>
								<v-icon
									class="right"
									style="transform: translate(50%,0)"
									color="green"
									slot="activator"
									v-if="props.item.amountPaid === props.item.totalCosts && props.item.paid !== '-1'"
									>checked</v-icon
								>
								<v-icon
									class="right"
									style="transform: translate(50%,0)"
									color="red"
									slot="activator"
									v-if="props.item.paid == '-1'"
									>checked</v-icon
								>
							</td>
							<td class="text-xs-left hidden-xs-only">
								<span class="other reservationStatus">{{
									props.item.amountPaid !== props.item.totalCosts
										? props.item.daysOpen
										: ''
								}}</span>
							</td>
							<td class="text-xs-left hidden-xs-only">
								<v-tooltip
									top
									v-if="props.item.amountPaid === props.item.totalCosts || props.item.paid === '-1'"
								>
									<v-icon
										style="transform: translate(20%,0)"
										color="green"
										slot="activator"
										v-if="props.item.paid !== '0' && props.item.paid !== '-1'"
										>checked</v-icon
									>
									<v-icon
										style="transform: translate(20%,0)"
										color="red"
										slot="activator"
										v-if="props.item.paid == '-1'"
										>checked</v-icon
									>
									<span>{{ getPaidDescription(props.item.paid) }}</span>
								</v-tooltip>

								<v-btn
									flat
									icon
									color="grey"
									@click="showHistory(props.item, true)"
								>
									<v-icon>mail</v-icon>
								</v-btn>
								<v-btn
									flat
									icon
									color="grey"
									@click="downloadInvoice(props.item)"
								>
									<v-icon>picture_as_pdf</v-icon>
								</v-btn>
								<v-menu v-if="props.item.paid === '0' || (props.item.paid == '-1')" offset-y>
									<v-btn slot="activator">Wijzig</v-btn>
									<v-list>
										<v-list-tile
											v-for="(item, index) in paidOptions"
											:key="index"
											@click="updatePaid(props.item, item.value)"
										>
											<v-list-tile-title>{{ item.text }}</v-list-tile-title>
										</v-list-tile>
									</v-list>
								</v-menu>
							</td>
						</tr>
					</template>
				</v-data-table>
				<v-btn @click="getHistory(true)">Download</v-btn>
			</v-card>
		</vue-pull-refresh>
		<view-invoice ref="viewInvoice" :customDate="false"></view-invoice>
	</div>
</template>
<script>
import * as utils from '@/utils/utils';
import HistoryFilter from '@/components/History/HistoryFilter';
import VuePullRefresh from 'vue-pull-refresh';
import ViewInvoice from '@/components/Reservations/ViewInvoice';
import { _ } from 'vue-underscore';
export default {
	name: 'HistoryTable',
	components: { HistoryFilter, VuePullRefresh, ViewInvoice },
	data() {
		return {
			dialog: false,
			pagination: {
				sortBy: 'endDate',
				descending: true
			},
			selected: [],
			search: '',
			pullConfig: window.pullConfig,
			utils: utils,
			headers: [
				{
					text: '#',
					align: 'left',
					value: 'rentId'
				},
				{ text: 'Gebruiker', value: 'firstname' },
				{ text: 'Omschrijving', value: 'unitDescription' },
				{ text: 'Totaalbedrag', value: 'totalCosts' },
				{ text: 'Startdatum', value: 'startDate' },
				{ text: 'Einddatum', value: 'endDate' },
				{ text: 'Dagen open', value: 'daysOpen' },
				{ text: 'Betaling', value: 'paid' }
			],
			items: [],
			allItems: [],
			loading: true,
			filters: {
				open: true
			},
			paidOptions: utils.getPaidOptions(),
			totalOpen: 0
		};
	},
	beforeDestroy() {
		window.emitter.$off('updateHistory');
	},
	watch: {
		search(val) {
			this.searchRequest(val);
		}
	},
	created: function() {
		var self = this;
		this.getHistory(false);
		window.emitter.$on('updateHistory', function() {
			self.getHistory(false);
		});
	},
	methods: {
		getHistory(download) {
			var self = this;
			self.loading = true;
			return utils
				.setData(
					basePath + 'api/reservations/history/' + (download ? '1' : '0'),
					this.filters
				)
				.then(function(json) {
					self.loading = false;
					if (!download) {
						self.allItems = json.data;
						self.items = self.allItems;
						self.totalOpen = self.allItems
							.reduce((s, f) => {
								return (
									s +
									(f.paid === '0'
										? parseFloat(f.totalCosts) - parseFloat(f.amountPaid)
										: 0)
								);
							}, 0)
							.toFixed(2);
					} else {
						window.location.href =
							basePath + 'api/downloader/downloadInvoicesOpen/' + json.data;
					}
				});
		},
		showHistory(reservation, showMail) {
			//  reservation.edit = true;
			reservation.showMail = showMail;
			this.$emit('showHistory', reservation);
		},
		toggleAll() {
			if (this.selected.length) this.selected = [];
			else this.selected = this.items.slice();
		},
		getPaidDescription(id) {
			if (id) {
				var paidOptions = utils.getPaidDescriptions();
				var selected = _.findWhere(paidOptions, { value: id });
				return selected.text;
			} else {
				return '';
			}
		},
		changeSort(column) {
			if (this.pagination.sortBy === column) {
				this.pagination.descending = !this.pagination.descending;
			} else {
				this.pagination.sortBy = column;
				this.pagination.descending = false;
			}
		},
		setFilter(data) {
			let self = this;
			this.pagination.page = 1;
			this.filters = data;
			this.getHistory(false).then(function() {
				self.searchRequest(self.search);
			});
		},
		onRefresh() {
			const self = this;
			return new Promise(function(resolve, reject) {
				self.getHistory(false).then(function() {
					setTimeout(function() {
						resolve();
					}, 500);
				});
			});
		},
		updatePaid(item, value) {
			var paymentData = {
				rentId: item.rentId,
				paid: value
			};
			item.paid = value;
			return utils
				.setData(basePath + 'api/reservations/updateHistoryPaid/', paymentData)
				.then(function(json) {
					item.transactionId = "1";
				});
		},
		getTempCustomer(reservation) {
			return reservation.tempCustomerName
				? ' (' + reservation.tempCustomerName + ')'
				: '';
		},
		searchRequest(val) {
			let self = this;
			let searchText = val.toLowerCase();
			let searchableItems = this.allItems;
			var options = {
				shouldSort: true,
				findAllMatches: true,
				threshold: 0.1,
				location: 0,
				distance: 200,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					'reservationNumber',
					'rentId',
					'firstname',
					'lastname',
					'car',
					'remark',
					'username',
					'unitDescription',
					'tempCustomerName',
					'companyname',
					'name'
				]
			};
			if (val == '') {
				this.items = searchableItems;
			} else {
				this.$search(searchText, searchableItems, options).then(results => {
					self.items = results;
				});
			}
		},
		downloadInvoice(reservation) {
			var self = this;
			utils
				.setData(
					basePath + 'api/reservations/getInvoice/' + reservation.rentId,
					{
						invoiceDate: ''
					}
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadInvoice/' +
						json.data +
						'/' +
						reservation.reservationNumber;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/History/HistoryTable.vue